__turbopack_context__.v({
  "Label": "ujLneq_Label",
  "Option": "ujLneq_Option",
  "OptionSelected": "ujLneq_OptionSelected",
  "Radio": "ujLneq_Radio",
  "Root": "ujLneq_Root",
  "skeleton-loading": "ujLneq_skeleton-loading",
});
